﻿import { TopicConstant } from "../constants/topic-constant";

const routeOptions = [
    {
        path: '/',
        name: 'default',
        view: 'main-page/index',
        display: 'Home',
        meta: {
            showInMenu: true
        }
    },
    {
        path: '/401-forbidden',
        name: 'forbidden',
        view: 'errors/error-401-forbidden',
        display: '401 Forbidden'
    },
    {
        path: '/404-not-found',
        name: 'not-found',
        view: 'errors/error-404-not-found',
        display: '404 Page Not Found'
    },
    {
        path: '/login',
        name: 'login',
        view: 'auth/login',
        meta: {
            useDarkFooter: true,
            useStrippedHeader: true
        }
    },
    {
        path: '/registration:step?',
        name: 'registration',
        view: 'auth/registration/registration',
        meta: {
            useDarkFooter: true,
            useStrippedHeader: true
        }
    },
    {
        path: '/auth/forgot-password',
        view: 'auth/forgot-password',
        meta: {
            useDarkFooter: true,
            useStrippedHeader: true
        }
    },
    {
        path: '/passwordrecovery/confirm',
        view: 'auth/reset-password',
        meta: {
            useDarkFooter: true,
            useStrippedHeader: true
        },
        props: (route) => ({
            token: route.query.token,
            guid: route.query.guid
        })
    },
    {
        path: '/auth/confirm-email',
        view: 'auth/confirm-email',
        props: (route) => ({
            userId: route.query.userId,
            token: route.query.token
        })
    },
    {
        path: '/profile',
        view: 'profile/account',
        display: 'Edit account',
        meta: {
            auth: true
        },
        //display for childrens is a key for multi-language
        children: [{
            path: 'edit-account',
            display: 'editMyAccount',
            view: 'profile/edit-account',
            meta: {
                auth: true,
                icon: 'user'
            }
        },
        {
            path: 'manage-address',
            display: 'myAddress',
            view: 'profile/manage-address',
            meta: {
                auth: true,
                icon: 'address'
            }
        },
        {
            path: 'quotation-history',
            display: 'myQuotes',
            view: 'profile/quotation-history',
            meta: {
                auth: true,
                icon: 'quotes'
            }
        },
        {
            path: 'change-password',
            display: 'changePassword',
            view: 'profile/change-password',
            meta: {
                auth: true,
                icon: 'lock'
            }
        }
        ]
    },
    {
        path: '/faqs',
        view: 'information/faq',
        display: 'FAQs',
        meta: {
            auth: false
        }
    },
    {
        path: '/terms-of-use',
        view: 'information/terms-of-use',
        display: 'Terms of Use',
        meta: {
            auth: false
        },
    },
    {
        path: '/privacy-policy',
        view: 'information/privacy-policy',
        display: 'Privacy Policy',
        meta: {
            auth: false
        },
    },
    {
        path: '/fuse-coverage',
        view: 'information/static-page',
        display: 'Fuse Coverage',
        meta: {
            auth: false
        },
        props: (route) => ({
            systemName: TopicConstant.fuseCoveragePageSystemName
        })
    },
    {
        path: '/circuit-breaker-coverage',
        view: 'information/static-page',
        display: 'Circuit Breaker Coverage',
        meta: {
            auth: false
        },
        props: (route) => ({
            systemName: TopicConstant.сircuitBreakerCoverageSystemName
        })
    },
    {
        path: '/about-us',
        view: 'information/about/about-us',
        display: 'About Us',
        meta: {
            auth: false
        }
    },
    {
        path: '/conflict-minerals-sourcing',
        view: 'information/static-page',
        display: 'Conflict Minerals Sourcing Policy',
        meta: {
            auth: false
        },
        props: (route) => ({
            systemName: TopicConstant.conflictMineralsSourcingPolicySystemName
        })
    },
    {
        path: '/page',
        view: 'information/static-page',
        props: (route) => ({
            systemName: route.query.p
        })
    },
    {
        path: '/installation-guides',
        view: 'information/installation-guides',
        meta: {
            auth: false
        },
    },
    {
        path: '/contact-us',
        view: 'information/contact-us',
        display: 'Contact us',
        meta: {
            auth: false
        },
    },
    {
        path: '/quote',
        view: 'quote/quote-list',
        display: 'Quote Card',
        meta: {
            auth: false
        },
    },
    {
        path: '/categories',
        name: 'product-categories',
        view: 'category/product-categories',
        display: 'Product Categories',
        props: (route) => ({
            categoryName: route.query.categoryName
        })
    },
    {
        path: '/dc-power-distribution/:categoryId?',
        view: 'category/product',
        display: 'Categories',
        props: (route) => ({
            mainCategorySlug: route.path.replace('/', ''),
            view: route.query.view
        })
    },
    {
        path: '/dc-circuit-breakers/:categoryId?',
        view: 'category/product',
        display: 'Categories',
        props: (route) => ({
            mainCategorySlug: route.path.replace('/', ''),
            view: route.query.view
        })
    },
    {
        path: '/dc-fuses-and-disconnects/:categoryId?',
        view: 'category/product',
        display: 'Categories',
        props: (route) => ({
            mainCategorySlug: route.path.replace('/', ''),
            view: route.query.view
        })
    },
    {
        path: '/accessories/:categoryId?',
        view: 'category/product',
        display: 'Categories',
        props: (route) => ({
            mainCategorySlug: route.path.replace('/', ''),
            view: route.query.view
        })
    },
    {
        path: '/dc-power-distribution/:categoryId/:productId',
        view: 'category/product-card',
        display: 'Product'
    },
    {
        path: '/dc-circuit-breakers/:categoryId/:productId',
        view: 'category/product-card',
        display: 'Product'
    },
    {
        path: '/dc-fuses-and-disconnects/:categoryId/:productId',
        view: 'category/product-card',
        display: 'Product'
    },
    {
        path: '/accessories/:categoryId/:productId',
        view: 'category/product-card',
        display: 'Product'
    },
    {
        path: '/search',
        view: 'search/search-product',
        display: 'Search Result',
        name: 'search',
        props: (route) => ({
            term: route.query.term
        }),
        meta: {
            auth: false
        },
    },
    {
        path: '/blogs',
        view: 'blog/blog',
        display: 'Blogs',
        name: 'blogs',
        meta: {
            auth: false
        },
    },
    {
        path: '/blogs/:blogId',
        view: 'blog/blog-detail',
        display: 'Blog detail',
        name: 'blog-detail',
        props: (route) => ({
            blogId: route.params.blogId
        }),
        meta: {
            auth: false
        },
    },
    {
        path: '/:catchAll(.*)',
        redirect: {
            name: 'not-found'
        }
    },
    {
        path: '/product/compare',
        view: 'category/product-compare',
        display: 'Compare'
    }
];

function addDynamicImport(route) {
    if (!route.view)
        return route;

    if (route.children && route.children.length) {
        route.children = route.children.map(child => {
            return addDynamicImport(child);
        });
    }

    return {
        ...route,
        component: async () => {
            const comps = import.meta.glob('../components/views/**/*.vue');
            const match = comps[`../components/views/${route.view}.vue`];

            return (await match()).default;
        }
    };
}

const routes = routeOptions.map(route => {
    return addDynamicImport(route);
});

export { routes };